import { render, staticRenderFns } from "./StudentType.vue?vue&type=template&id=7a28016c&scoped=true"
import script from "./StudentType.vue?vue&type=script&lang=js"
export * from "./StudentType.vue?vue&type=script&lang=js"
import style0 from "./StudentType.vue?vue&type=style&index=0&id=7a28016c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a28016c",
  null
  
)

export default component.exports